<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-grid"></i>
        <div class="mg-l-20">
          <h4>
            {{ $t("router.库存明细") }}
            <span v-if="warehouseName" class="mg-l-5 tx-16"
              >( {{ warehouseName }} )</span
            >
          </h4>
          <div class="tx-14" style="line-height: 14px" v-if="warehouseAddress">
            <span>{{ $t("rm.仓库地址：") }}</span>
            <span>{{ warehouseAddress }}</span>
          </div>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success mg-r-15"
          v-if="isSysRights('Warehouse.importCheckInventory')"
          @click="importStorage"
        >
          {{ $t("rm.导入盘库数据") }}
        </button>
        <button
          class="btn btn-success"
          v-if="isSysRights('Warehouse.exportWarehouseSku')"
          @click="exportData"
        >
          {{ $t("warehouse.导出数据") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyName')"
        >
          {{ $t("product.商品名称：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keySku"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keySku')"
        >
          SKU:&nbsp;
          <span class="mg-r-10">{{ keySku }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keySku", "warehouseName", "warehouseAddress"],
  methods: {
    // 导入盘库数据
    importStorage() {
      $("#modalImportStorage").modal("show");
    },
    // 导出数据
    exportData() {
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      this.$parent.loading = true;
      $.api_call(
        "api.Warehouse.exportWarehouseSku",
        {
          warehouseId: this.$route.query.id,
          skuName: this.keyName,
          sku: this.keySku,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            this.$parent.checkArr = [];
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            openDownload(r.Data.Results);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this.$parent[type] = "";
      this.$parent.toPage(1);
    },
  },
};
</script>
